import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 移动端300毫秒点击延迟解决方案
// 项目运行 npm install fastclick  --save
// import fastClick from 'fastclick'
// 使用fastClick
// fastClick.attach(document.body)

//多语言包
// import i18n from './lang' // internationalization

//引入element,全引入
import ElementUI from 'element-ui';

//element按需引入
// import element from './element/index'

import 'element-ui/lib/theme-chalk/index.css';

//引入iconfont
// import './assets/icon/iconfont.css';
import './assets/icons/iconfont.css';

//excel
// import Blob from './excel/Blob'
// import Export2Excel from './excel/Export2Excel.js'

//引入两个文件
import api from './api/api'
import http from './api/http'
//挂载到VUE实例，以便全局使用
Vue.prototype.api = api;
Vue.prototype.http = http;

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


import EventBus from '@/bus/bus'
Vue.use(EventBus)
Vue.prototype.$EventBus = EventBus

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {

  fullscreenEl: false,

}
Vue.use(preview, options)
Vue.use(preview)


Vue.config.productionTip = false;

// Vue.use(element);
Vue.use(ElementUI);

new Vue({
  router,
  // i18n,
  store,
  render: h => h(App)
}).$mount('#app');
